import type { ScheduledDetailedCopy } from './scheduled-page-copy-translations';

export const scheduledDetailedCopyIndonesian = {
  id: {
    status: {
      upcoming: 'Akan datang',
      running: 'Sedang berjalan',
      waitingBackground: 'Menunggu pekerjaan latar belakang',
      succeeded: 'Berhasil',
      failed: 'Gagal',
      skipped: 'Dilewati',
      needsAttention: 'Perlu perhatian',
      unknownOutcome: 'Hasil tidak diketahui',
      canceled: 'Dibatalkan',
      malformed: 'Tidak tersedia',
      paused: 'Dijeda',
    },
    editor: {
      createTitle: 'Jadwal baru',
      editTitle: 'Edit jadwal',
      description: 'Atur tugas, waktu, konteks, dan wewenang tanpa pengawasan.',
      stepOf: 'Langkah {step} dari 4',
      task: 'Tugas',
      timing: 'Waktu',
      execution: 'Pelaksanaan',
      review: 'Tinjau',
      name: 'Nama jadwal',
      namePlaceholder: 'mis. ringkasan kinerja hari Senin',
      instructions: 'Instruksi agen',
      instructionsPlaceholder:
        'Jelaskan hasil yang harus dibuat agen dan tempat agen boleh bertindak.',
      sourceChat: 'Chat sumber',
      scheduleThisChat: 'Jadwalkan chat ini',
      sourceSnapshot:
        'Cuplikan privat dibuat saat disimpan. Perubahan chat setelahnya tidak akan mengubah jadwal ini.',
      sourceUnavailable:
        'Chat sumber tidak tersedia atau Anda tidak lagi memiliki akses.',
      sourceChatLockedNote:
        'Jadwal yang menggunakan kembali chat sumber harus memakai konteks persisten dan visibilitas privat.',
      recurrence: 'Pengulangan',
      once: 'Satu kali',
      hourly: 'Setiap jam',
      daily: 'Setiap hari',
      weekdays: 'Hari kerja',
      selectedWeekdays: 'Hari tertentu dalam seminggu',
      weekly: 'Setiap minggu',
      monthly: 'Setiap bulan',
      date: 'Tanggal',
      time: 'Waktu setempat',
      dayOfMonth: 'Tanggal dalam bulan',
      whenPlaceholder: 'YYYY-MM-DD',
      whenInvalid: 'Masukkan tanggal dalam format YYYY-MM-DD.',
      end: 'Berakhir',
      never: 'Tidak pernah',
      onDate: 'Pada tanggal tertentu',
      afterOccurrences: 'Setelah sejumlah eksekusi',
      occurrences: 'Eksekusi',
      nextRuns: 'Eksekusi berikutnya',
      schedulePreview: 'Pratinjau jadwal',
      noEndDate: 'Tanpa tanggal berakhir.',
      runsUntil: 'Berjalan hingga {date}.',
      totalRuns: 'Total {count} kali berjalan.',
      resolvingTime: 'Server sedang memeriksa waktu setempat ini…',
      serverTimeRequired:
        'Server harus mengonfirmasi waktu setempat ini sebelum disimpan.',
      contextMode: 'Konteks chat',
      persistent: 'Konteks berkelanjutan',
      persistentDescription:
        'Gunakan kembali satu chat milik jadwal untuk semua eksekusi.',
      isolated: 'Chat baru setiap eksekusi',
      isolatedDescription: 'Mulai setiap eksekusi dengan konteks terpisah.',
      visibility: 'Visibilitas',
      private: 'Privat',
      privateDescription:
        'Hanya Anda yang dapat melihat perintah lengkap, percakapan, aktivitas alat, dan hasil.',
      workspace: 'Ruang kerja',
      workspaceWarning:
        'Berbagi dengan ruang kerja menampilkan perintah lengkap, percakapan, aktivitas alat, dan hasil.',
      creditPolicy: 'Kebijakan kredit ruang kerja',
      creditsAvailable:
        'Eksekusi memakai saldo kredit dan batas ruang kerja yang berlaku.',
      creditsUnavailable:
        'Ruang kerja ini tidak memiliki kredit yang tersedia. Jadwal dapat dijeda saat dijalankan.',
      fullAuthorityTitle: 'Tindakan agen',
      fullAuthorityDescription:
        'Pada setiap eksekusi, agen memeriksa ulang akses Anda dan dapat melakukan tindakan merusak tanpa bertanya.',
      authorityAcknowledgment:
        'Izinkan tindakan apa pun tanpa meminta persetujuan terlebih dahulu.',
      authorityRequired:
        'Izinkan tindakan agen untuk membuat jadwal ini. Proses berjalan tanpa pengawasan, jadi tidak ada yang bisa menyetujuinya nanti.',
      recurrenceUnresolved:
        'Waktu jalan ini tidak dapat dipastikan. Pilih ulang tanggal dan waktunya.',
      notifications: 'Notifikasi dalam aplikasi',
      notificationsDescription:
        'Anda akan mendapat satu notifikasi untuk hasil akhir yang memerlukan perhatian.',
      reviewSummary:
        'Tinjau tugas dan frekuensi dengan teliti sebelum membuat jadwal.',
      required: 'Kolom ini wajib diisi.',
      invalid: 'Masukkan nilai yang valid.',
      past: 'Pilih waktu di masa depan.',
      endBeforeStart: 'Akhiri jadwal setelah proses pertamanya.',
      draftRestored: 'Draf Anda yang belum disimpan telah dipulihkan.',
      tooLong: 'Nilai ini terlalu panjang.',
      createDisabled:
        'Anda tidak memiliki izin untuk membuat jadwal di ruang kerja ini.',
      saved: 'Jadwal disimpan',
      unsavedTitle: 'Buang perubahan yang belum disimpan?',
      unsavedDescription:
        'Perubahan pada jadwal ini akan hilang jika Anda menutupnya sekarang.',
      discardChanges: 'Buang perubahan',
    },
    detail: {
      title: 'Detail jadwal',
      cadence: 'Frekuensi',
      owner: 'Pemilik',
      timezone: 'Zona waktu',
      nextRun: 'Eksekusi berikutnya',
      lastRun: 'Eksekusi terakhir',
      prompt: 'Perintah lengkap',
      sourceContext: 'Konteks sumber tersimpan',
      executionMode: 'Mode eksekusi',
      recentUsage: 'Penggunaan terbaru',
      credits: 'kredit',
      tools: 'tindakan',
      history: 'Riwayat eksekusi',
      transcript: 'Percakapan',
      resultFiles: 'File hasil',
      noResultFiles: 'Tidak ada file hasil yang direkam untuk proses ini.',
      noRuns: 'Belum ada eksekusi.',
      noTranscript: 'Belum ada percakapan untuk eksekusi ini.',
      toolActivity: 'Aktivitas',
      toolInput: 'Detail tugas',
      toolResult: 'Hasil',
      noToolActivity: 'Tidak ada aktivitas untuk eksekusi ini.',
      loadMore: 'Muat lagi',
      preview: 'Pratinjau',
      sourceScheduled: 'Terjadwal',
      sourceManual: 'Sesuai permintaan',
      sourceWatchdog: 'Pemulihan',
      roleUser: 'Pengguna',
      roleAssistant: 'Asisten',
      roleTool: 'Alat',
      roleSystem: 'Sistem',
      runNow: 'Jalankan sekarang',
      pause: 'Jeda',
      resume: 'Lanjutkan',
      share: 'Bagikan dengan ruang kerja',
      unshare: 'Jadikan privat',
      cancelRun: 'Batalkan eksekusi aktif',
      archive: 'Arsipkan',
      deleteSchedule: 'Hapus jadwal',
      openThread: 'Lihat utas',
      confirmArchive: 'Arsipkan jadwal ini?',
      confirmArchiveDescription:
        'Pekerjaan mendatang akan dibatalkan. Riwayat dan catatan audit tetap disimpan.',
      confirmDelete: 'Hapus jadwal ini?',
      confirmDeleteDescription:
        'Jadwal ini akan dihapus secara permanen. Percakapan lama dan hasil yang dibuat tetap ada di ruang kerja.',
      confirmUnshareDescription:
        'Anggota ruang kerja akan segera kehilangan akses ke prompt, transkrip, aktivitas alat, dan hasil.',
      confirmCancel: 'Batalkan eksekusi aktif?',
      confirmCancelDescription:
        'Eksekusi akan berhenti pada titik pembatalan aman berikutnya.',
      actionCompleted: 'Jadwal diperbarui',
      permissionDenied:
        'Anda dapat melihat jadwal ini, tetapi hanya pemilik atau administrator jadwal yang dapat mengubahnya.',
      needsAttention:
        'Eksekusi ini perlu ditinjau sebelum pekerjaan tanpa pengawasan dilanjutkan.',
      runDetails: 'Detail eksekusi',
    },
    notifications: {
      completed: 'Eksekusi terjadwal selesai',
      failed: 'Eksekusi terjadwal gagal',
      attention: 'Eksekusi terjadwal perlu perhatian',
      missed: 'Eksekusi terjadwal satu kali terlewat',
      viewRun: 'Lihat eksekusi',
      empty: 'Belum ada notifikasi eksekusi.',
      unread: 'Belum dibaca',
      read: 'Sudah dibaca',
      caughtUp: 'Semua notifikasi sudah dilihat.',
    },
    errors: {
      generic: 'Terjadi kesalahan. Coba lagi.',
      permission: 'Anda tidak memiliki izin untuk melakukan tindakan ini.',
      disabled: 'Agen terjadwal belum diaktifkan untuk ruang kerja ini.',
      credits: 'Ruang kerja tidak memiliki kredit yang cukup.',
      limit: 'Ruang kerja telah mencapai batas jadwal aktif.',
      runPending:
        'Sudah ada eksekusi yang tertunda atau sedang berjalan untuk jadwal ini.',
      invalidTime: 'Pilih waktu mendatang yang valid.',
      notFound: 'Jadwal atau eksekusi ini tidak lagi tersedia.',
    },
  },
} satisfies Record<'id', ScheduledDetailedCopy>;
